// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import JsonExcel from 'vue-json-excel'
import Vuex from 'vuex'

import Notifications from 'vue-notification'
Vue.use(Notifications)

import Pagination from 'vue-pagination-2';
Vue.component('pagination', Pagination);

import ServerError from './views/pages/500'
Vue.component('ServerError', ServerError)

window.axios = require('axios')


import SimpleVueValidation from 'simple-vue-validator';
Vue.use(SimpleVueValidation);
Vue.prototype.Validator = SimpleVueValidation.Validator;

// Vue.prototype.baseURL = 'https://vast-bastion-0*0210.herokuapp.com' //Development Server URL
// axios.defaults.baseURL = 'https://vast-bastion-00210.herokuapp.com' //Development Server URL
Vue.prototype.baseURL = 'https://shopio.fawzlabs.com' //Development Server URL
axios.defaults.baseURL = 'https://shopio.fawzlabs.com' //Development Server URL
axios.defaults.timeout = 60000;


import vDialogs from 'v-dialogs';
Vue.use(vDialogs, { language: 'en' });

import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

// todo
// cssVars()
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
